/** 外車端 API（openspec add-external-driver-grab）；全部走 extApiClient，不碰 services/* */
import { extBindPost, extGet, extPost, extPut, saveExtToken, EXT_KEYS } from './extApiClient'
import type { ExtBatchResponse, ExtBindRequest, ExtDriver, ExtGrabResponse, ExtLoginResponse, ExtMission } from './types'

export async function bindExtDriver(req: ExtBindRequest): Promise<ExtLoginResponse> {
  const data = await extBindPost<ExtLoginResponse>('/line/ext/drivers/bind', req)
  if (data.bound) {
    saveExtToken(data.accessToken, data.accessTokenExpiresIn)
    localStorage.removeItem(EXT_KEYS.lineUserToken)
  }
  return data
}

export function getExtMe(): Promise<ExtDriver> {
  return extGet<ExtDriver>('/line/ext/drivers/me')
}

export function updateExtMe(req: ExtBindRequest): Promise<ExtDriver> {
  return extPut<ExtDriver>('/line/ext/drivers/me', req)
}

export function getExtBatch(token: string): Promise<ExtBatchResponse> {
  return extGet<ExtBatchResponse>(`/line/ext/batches/${encodeURIComponent(token)}`)
}

export function grabExtBatch(token: string): Promise<ExtGrabResponse> {
  return extPost<ExtGrabResponse>(`/line/ext/batches/${encodeURIComponent(token)}/grab`)
}

export function completeExtMission(missionId: string, containerNo?: string): Promise<ExtMission> {
  return extPut<ExtMission>(`/line/ext/missions/${encodeURIComponent(missionId)}/complete`, {
    containerNo: containerNo && containerNo.trim() ? containerNo.trim() : null,
  })
}

/** 取消接單：執行中 → 回搶單池（比照會員 cancelMyTask，2026-09-29）；帶 pairedMissionId = 雙拖兩筆都取消 */
export function cancelExtMission(missionId: string, pairedMissionId?: string | null): Promise<string[]> {
  return extPost<string[]>(`/line/ext/missions/${encodeURIComponent(missionId)}/cancel`, { pairedMissionId: pairedMissionId ?? null })
}

/** 某天接的單（yyyy-MM-dd），不分狀態 */
export function getExtHistory(date: string): Promise<ExtMission[]> {
  return extGet<ExtMission[]>(`/line/ext/missions/history?date=${encodeURIComponent(date)}`)
}
